<template>
    <div class="chat">
        <div class="mtm_head">
            <span class="title">1:1채팅</span>
           <!--<span class="btn_out" @click="roomExit">나가기</span>-->
            <base-button-sm :mode="btn-danger" @click="roomExit">나가기</base-button-sm>
        </div>
        
            <chat-base :chat_roomId="mtm_id" :roomout="outsignal" @update-userlist="updateuserlist"></chat-base>    
        
    </div>
</template>
<script>
import ChatBase from "@/components/chat/ChatBase.vue";
export default {
    props: ["mtm_id"], 
    data(){
        return{
            outsignal: "",
        }
    },
    components: {
        ChatBase,    
    },
    methods:{
        roomExit()
        {
            this.outsignal=this.mtm_id;
            //this.$router.push("/chat/lobby");
            window.close();    
        }
    }  

}
</script>
<style lang="scss" scoped>
.chat {
    height:calc(100vh - 46px);
    .mtm_head{
        display:flex;
        justify-content: space-between;
        background:#000;
        padding:10px;
        color:white;
        font-family:'맑은고딕';
        font-weight:bold;
        .title{
            font-size:16px;           
        }
        .btn_out{
            cursor:pointer;
            color:yellow;
        }
    }
}
   
</style>